<app-access-item [icon]="'/assets/icons/building.svg'" [iconColor]="iconColor()" [hideOverflow]="true">
  <app-access-item-header>
    @if (isTeamMember() && galleryPermissions().can_edit && ('groups:list' | billingScope)) {
      <span>Everyone at</span>
      <app-context-menu [options]="{ noSpacing: true }" #userGroupMenu>
        <b contextButton class="tenant-name"
          >{{ tenant().name }}
          <app-svg src="/assets/icons/12/chevron-down.svg"></app-svg>
        </b>

        <div contextContent class="user-groups-dropdown">
          @if (userGroupMenu.isOpen()) {
            <b>User Groups</b>
            @if (allUserGroups$ | async; as userGroups) {
              @if (groupUsersEnabledMap$ | async; as groupUsersEnabledMap) {
                @for (group of userGroups; track $index) {
                  <app-radio-button
                    [checkStyle]="'check'"
                    [checked]="groupUsersEnabledMap[group.id]"
                    (click)="toggleUserGroup(group.id, !groupUsersEnabledMap[group.id])"
                    [hasIcon]="true"
                    name="group-toggle"
                    spacing="2"
                    [fullWidth]="true"
                    location="team-access-item"
                    class="user-group-dropdown-item"
                  >
                    <app-svg src="/assets/icons/team.svg"></app-svg>
                    <span class="group-name">{{ group.name }}</span>
                    @if (groupUserCountMap$ | async; as groupUserCountMap) {
                      <span class="user-count">({{ groupUserCountMap[group.id] }})</span>
                    }
                  </app-radio-button>
                }
              }
            }
          }
        </div>
      </app-context-menu>
    } @else {
      <span>Everyone at</span><b>{{ tenant().name }}</b>
    }
  </app-access-item-header>
  @if (isTeamMember()) {
    <app-access-item-body> {{ teamSize() }} People </app-access-item-body>
  }
  <app-access-item-cta>
    <app-gallery-share-context
      itemCta
      [currentAccessLevel]="tenantAccessLevel()"
      [accessLevels]="tenantAccessLevels"
      [mode]="'team'"
      (onChange)="changeTeamAccessLevel($event)"
      [disabled]="!isTeamMember() || !galleryPermissions().can_edit"
      [type]="'gallery'"
    ></app-gallery-share-context>
  </app-access-item-cta>
</app-access-item>
